import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useCreateLocationMutation } from 'services/location';

import {
  TextInput,
  Form,
  FormGroup,
  Modal,
  ProgressIndicator,
  ProgressStep,
  Row,
  Column,
} from '@carbon/react';

import styles from './LocationWizard.module.scss';
import cx from 'classnames';
import { openLocationForm } from '@/redux/new_services/forms';

// LocationWizard – Betriebs-Art wurde entfernt, weil die Gruppen-
// Zuordnung über die Organisation diese Klassifizierung inzwischen
// vollständig übernimmt. Übrig sind die zwei wirklich nötigen Schritte:
// Name + Adressdaten.
const LocationWizard = ({hideModal}) => {
  const dispatch = useDispatch();
  const max_steps = 2;


  const [form, setForm] = useState({
    name: '',
    notes: '',
    address: {
      street: '',
      postcode: '',
      city: '',
    },
  });

  const [step, setStep] = useState(1);
  const [validation, setValidation] = useState([]);

  const [
    createLocation,
    {
      isLoading: isSaving,
      isSuccess,
      error,
      data: createdLocation,
    }
  ] = useCreateLocationMutation();

  const changeField = useCallback(
    (event) => {
      const { currentTarget } = event;
      const { field, valuetype } = currentTarget.dataset;

      let value = currentTarget.value;
      if (valuetype) {
        switch (valuetype) {
          case 'number':
            value = Number(value);
            break;
          default:
        }
      }

      const splitField = field.split('_');

      if (splitField.length > 1) {
        setForm({
          ...form,
          [splitField[0]]: {
            ...form[splitField[0]],
            [splitField[1]]: value,
          },
        });
      } else {
        setForm({
          ...form,
          [field]: value,
        });
      }
    },
    [form, setForm]
  );

  const inValidate = useCallback(
    (step, state) => {
      const i = validation.findIndex((s) => s.step === step);
      if (i >= 0) {
        validation[i].invalid = state;
        setValidation(validation);
      } else {
        setValidation([...validation, { step: step, invalid: state }]);
      }
    },
    [validation, setValidation]
  );

  const isStepInValid = useCallback(
    (step) => {
      return validation.find((s) => s.step === step && s.invalid === true)
        ? true
        : false;
    },
    [validation]
  );

  const handleSubmit = () => {
    const currentStep = step;
    if (currentStep === max_steps) {
      //this.props.assignDevice(this.props.item.model.ID, this.state.item.label);
      //dispatch(modalActions.hideModal());
      //dispatch(locationActions.create(form));
      createLocation({...form}).unwrap().then((result) => {
        console.info("create result:", result);
        if (result.data && result.data.model && result.data.model.ID) {
          dispatch(openLocationForm(result.data.model.ID));
        }
        dispatch(hideModal());
      });
    } else {
      switch (currentStep) {
        case 1:
          if (!form.name || form.name.length < 4) {
            inValidate(currentStep, true);
          } else {
            inValidate(currentStep, false);
            setStep(step + 1);
          }
          break;
        default:
      }
    }
  };

  const handleAbort = (e) => {
    const { currentTarget: button } = e;

    if (button && button.className === 'cds--modal-close') {
      hideModal();
      return;
    }

    if (step > 1) {
      setStep(step - 1);
    } else {
      hideModal();
    }
  };

  let render_form;

  const already_checked = validation.find((v) => v.step === step)
    ? true
    : false;
  switch (step) {
    case 1:
      {
        const { name } = form;

        render_form = (
          <FormGroup legendText="">
            <TextInput
              id="form_name"
              labelText="Name für den Standort"
              value={name}
              invalid={already_checked && name.length < 4}
              helperText="Das System sollte einen kurzen Namen haben um es schneller wieder finden zu können."
              invalidText="Der Name brauch eine mindest länge von 4 Zeichen"
              data-field="name"
              onChange={changeField}
            />
          </FormGroup>
        );
      }
      break;
    case 2:
      {

        render_form = (
          <FormGroup legendText="">
            <TextInput
              labelText="Straße"
              value={form.address.street}
              id="form_address_street"
              onChange={changeField}
              data-field="address_street"
            />
            <Row>
              <Column sm={3} md={3} lg={3}>
                <TextInput
                  labelText="PLZ"
                  value={form.address.postcode}
                  id="form_address_postcode"
                  onChange={changeField}
                  data-field="address_postcode"
                />
              </Column>
              <Column>
                <TextInput
                  labelText="Ort"
                  value={form.address.city}
                  id="form_address_city"
                  onChange={changeField}
                  data-field="address_city"
                />
              </Column>
            </Row>
          </FormGroup>
        );
      }
      break;
    default:
  }

  return (
    <Modal
      open={true}
      danger={false}
      primaryButtonText={step === max_steps ? 'Anlegen' : 'Weiter'}
      secondaryButtonText={step > 1 ? 'Zurück' : 'Abrechen'}
      modalHeading="Neuen Standort anlegen"
      onRequestClose={handleAbort}
      onRequestSubmit={handleSubmit}
      className={cx(styles.Container)}>
      <ProgressIndicator currentIndex={step - 1}>
        <ProgressStep
          className={cx(styles.ProgressStepItem)}
          label="Benennen"
          invalid={isStepInValid(1)}
          description="Schritt 1: Name vergeben"
        />

        <ProgressStep
          className={cx(styles.ProgressStepItem)}
          label="Adressdaten"
          invalid={isStepInValid(2)}
          description="Schritt 2: Adressdaten eintragen"
        />
      </ProgressIndicator>
      <Form>
        {render_form}
      </Form>
    </Modal>
  );
};

export default LocationWizard;
